var map = {
	"./appstore.png": 2607,
	"./discord.png": 7305,
	"./down.png": 9044,
	"./has.png": 3533,
	"./home/key.png": 1829,
	"./home/top.png": 3958,
	"./home/zone.png": 7488,
	"./key/0.png": 5959,
	"./key/1.png": 4476,
	"./key/2.png": 5342,
	"./key/3.png": 6757,
	"./key/4.png": 3829,
	"./key/5.png": 1909,
	"./key/down.png": 5245,
	"./key/main.png": 8310,
	"./key/qa.png": 8470,
	"./key/right.png": 8057,
	"./key/use.png": 5878,
	"./logo.png": 9955,
	"./logo_white.png": 5219,
	"./medium.png": 6941,
	"./menus.png": 4444,
	"./product/0.png": 9845,
	"./product/1.png": 7049,
	"./product/2.png": 6816,
	"./product/3.png": 2905,
	"./product/4.png": 7791,
	"./product/5.png": 2837,
	"./product/main.png": 8698,
	"./reddit.png": 9794,
	"./right.png": 4216,
	"./support/0.png": 3305,
	"./support/1.png": 9382,
	"./support/2.png": 5907,
	"./support/3.png": 1010,
	"./support/data.png": 6933,
	"./support/key.png": 1785,
	"./support/lock.png": 7584,
	"./support/main.png": 7205,
	"./support/use.png": 911,
	"./support/view.png": 1440,
	"./telegram.png": 7516,
	"./twitter.png": 5542,
	"./up.png": 1121,
	"./youtube.png": 8244,
	"./zone/0.png": 4005,
	"./zone/1.png": 9374,
	"./zone/2.png": 5503,
	"./zone/3.png": 7250,
	"./zone/4.png": 4044,
	"./zone/5.png": 7524,
	"./zone/main.png": 5169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1078;